/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { Injectable } from '@angular/core';

/**
 * Provides the SchedulerApiConfiguration configuration object with a given root URL.
 */
export function provideSchedulerApiConfiguration(rootUrl: string) {
  var config = new SchedulerApiConfiguration();
  config.rootUrl = rootUrl;
  return {
    provide: SchedulerApiConfiguration,
    useValue: config
  };
}

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class SchedulerApiConfiguration {
  rootUrl: string = '/';
}

